import { contains as n } from "./utils/DOMutils.js";
import { getAllAffectedNodes as t } from "./utils/all-affected.js";
import { getFirst as u, toArray as s } from "./utils/array.js";
import { getActiveElement as e } from "./utils/getActiveElement.js";
var i = function (o, r) {
    return o === r;
  },
  a = function (o, r) {
    return !!s(o.querySelectorAll("iframe")).some(function (f) {
      return i(f, r);
    });
  },
  p = function (o, r) {
    return r === void 0 && (r = e(u(o).ownerDocument)), !r || r.dataset && r.dataset.focusGuard ? !1 : t(o).some(function (f) {
      return n(f, r) || a(f, r);
    });
  };
export { p as focusInside };